import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';
import InnerDefaults from '../fw/defaults/inner';
import PDQuality from '../modules/pd-quality';
import ShakaPlayer from '../streaming/shaka-player/shaka-player';
import HlsJS from '../streaming/hls-js/hls-js';
import NativeHls from '../streaming/native-hls';


export default class ApiSrc {

  #rmp;
  #nextReadingMp4 = false;
  #nextReadingHlsJS = false;
  #nextReadingShaka = false;
  #nextReadingHls = false;
  #setSrcAdReset = false;
  #setSrcResetAdInterval = null;
  // do NOT change to _nullFn
  #afterSrcSwitchFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #updateReadingSrc() {
    InnerDefaults.resetReading.call(this.#rmp);
    if (this.#rmp.hasDash && this.#rmp.okShaka && this.#rmp.dashFirst) {
      this.#rmp.readingDashShaka = true;
      this.#rmp.readingShaka = true;
      this.#rmp.readingPDorNative = false;
      this.#rmp.readingMse = true;
    } else if (this.#rmp.hasFps && this.#rmp.okFps) {
      this.#rmp.readingHls = true;
      this.#rmp.readingFps = true;
      this.#rmp.readingPDorNative = true;
      this.#rmp.readingMse = false;
    } else if (this.#rmp.hasHls && this.#rmp.okHlsJS && this.#rmp.hlsEngine === 'hlsjs') {
      this.#rmp.readingHlsJS = true;
      this.#rmp.readingPDorNative = false;
      this.#rmp.readingMse = true;
    } else if (this.#rmp.hasHls && this.#rmp.okShaka && this.#rmp.hlsEngine === 'shakaplayer') {
      this.#rmp.readingHlsShaka = true;
      this.#rmp.readingShaka = true;
      this.#rmp.readingPDorNative = false;
      this.#rmp.readingMse = true;
    } else if (this.#rmp.hasHls && this.#rmp.okHls) {
      this.#rmp.readingHls = true;
      this.#rmp.readingPDorNative = true;
      this.#rmp.readingMse = false;
    } else if (this.#rmp.hasDash && this.#rmp.okShaka) {
      this.#rmp.readingDashShaka = true;
      this.#rmp.readingShaka = true;
      this.#rmp.readingPDorNative = false;
      this.#rmp.readingMse = true;
    } else {
      this.#rmp.readingPDorNative = true;
      this.#rmp.readingMse = false;
      if (this.#rmp.audioOnly) {
        if (this.#rmp.hasM4a && (this.#rmp.okM4a || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.readingM4a = true;
        } else if (this.#rmp.hasMp3 && (this.#rmp.okMp3 || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.readingMp3 = true;
        } else if (this.#rmp.hasOgg && (this.#rmp.okOgg || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.readingOgg = true;
        } else {
          this.#rmp.rmpUtils.error(107);
        }
      } else {
        if (this.#rmp.hasMp4 && (this.#rmp.okMp4 || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.readingMp4 = true;
          this.#rmp.readingWebM = false;
        } else if (this.#rmp.hasWebM && (this.#rmp.okWebM || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.readingMp4 = true;
          this.#rmp.readingWebM = true;
        } else if (this.#rmp.playlistAudioOnly || this.#rmp.relatedAudioOnly || this.#rmp.audioOnlyUseVideoLayout) {
          if (this.#rmp.hasM4a && (this.#rmp.okM4a || this.#rmp.pdCheckCodecsDone)) {
            this.#rmp.readingM4a = true;
          } else if (this.#rmp.hasMp3 && (this.#rmp.okMp3 || this.#rmp.pdCheckCodecsDone)) {
            this.#rmp.readingMp3 = true;
          } else if (this.#rmp.hasOgg && (this.#rmp.okOgg || this.#rmp.pdCheckCodecsDone)) {
            this.#rmp.readingOgg = true;
          } else {
            this.#rmp.rmpUtils.error(107);
          }
        } else {
          this.#rmp.rmpUtils.error(107);
        }
      }
    }
  }

  #runNextPlayer() {
    this.#updateReadingSrc();
    if (this.#nextReadingHlsJS) {
      this.#rmp.rmpShakaPlayer = null;
      if (!this.#rmp.rmpHlsJS) {
        this.#rmp.rmpHlsJS = new HlsJS(this.#rmp);
      }
      this.#rmp.rmpHlsJS.init();
    } else if (this.#nextReadingShaka) {
      this.#rmp.rmpHlsJS = null;
      if (!this.#rmp.rmpShakaPlayer) {
        this.#rmp.rmpShakaPlayer = new ShakaPlayer(this.#rmp);
      }
      this.#rmp.rmpShakaPlayer.init();
    } else {
      this.#rmp.rmpHlsJS = null;
      this.#rmp.rmpShakaPlayer = null;
      //  reappend quality module if nextReadingMp4
      if (this.#nextReadingMp4) {
        this.#rmp.rmpModuleManagement.destroy('quality');
        this.#rmp.rmpPDQuality = new PDQuality(this.#rmp);
        this.#rmp.rmpPDQuality.init();
      } else if (this.#nextReadingHls) {
        this.#rmp.rmpNativeHls = new NativeHls(this.#rmp);
        this.#rmp.rmpNativeHls.init();
      }
      this.#resetHtml5MediaBuffer();
    }
  }

  #resetHtml5VideoTagEvents() {
    // runs in InitManagement createVideoTag
    if (Env.isIos[0]) {
      if (this.#rmp.hasExternalCCFiles) {
        this.#rmp.rmpInitManagement.unwireIosExternalCCFiles();
      }
      if (this.#rmp.hasNativeFullscreenSupport) {
        this.#rmp.rmpFullscreenManagement.unwireIosFullscreen();
      }
    }
    this.#rmp.rmpInitManagement.unwireHtml5VideoEvents();
    this.#rmp.dom.video.removeEventListener('ended', this.#rmp.endedFn);
    if (this.#rmp.rmpMediaSessionMetadata) {
      this.#rmp.rmpMediaSessionMetadata.unwire();
    }
    // not redone
    if (this.#rmp.rmpAirPlay) {
      this.#rmp.rmpAirPlay.destroy();
    }
    // not redone
    this.#rmp.dom.video.removeEventListener('volumechange', this.#rmp.onVolumeChangeFn);
    // not redone
    this.#rmp.rmpEventsManagement.unwireUnstalledBufferEvents();
    // not redone
    if (this.#rmp.rmpPip) {
      this.#rmp.rmpPip.unwirePiPEvents();
    }
  }

  #reAttachHtml5VideoEvents() {
    if (Env.isIos[0]) {
      if (this.#rmp.hasExternalCCFiles) {
        this.#rmp.rmpInitManagement.wireIosExternalCCFiles();
      }
      if (this.#rmp.hasNativeFullscreenSupport) {
        this.#rmp.rmpFullscreenManagement.wireIosFullscreen();
      }
      this.#rmp.dom.video.addEventListener('webkitbeginfullscreen', this.#rmp.webkitbeginfullscreenFn);
      this.#rmp.dom.video.addEventListener('webkitendfullscreen', this.#rmp.webkitendfullscreenFn);
    }

    this.#rmp.dom.video.addEventListener('volumechange', this.#rmp.onVolumeChangeFn);

    this.#rmp.rmpEventsManagement.wireUnstalledBufferEvents();

    if (this.#rmp.rmpPip) {
      this.#rmp.rmpPip.wirePiPEvents();
    }
  }

  #fireSrcChanged() {
    this.#rmp.changingSrc = false;
    if (this.#rmp.rmpMediaSessionMetadata) {
      this.#rmp.rmpMediaSessionMetadata.updatePositionState();
    }
    // to update CC and audio tracks overlay icons
    this.#rmp.one('playing', this.#rmp.updateOverlayModuleSelectionFn);
    this.#rmp.dispatch('srcchanged');
    this.#rmp.resolvePromise('setSrc');
  }

  #afterSrcSwitch(event) {
    this.#rmp.off('loadedmetadata error', this.#afterSrcSwitchFn);
    Logger.print('api', `setSrc finishes with event ${event.type}`);
    if (event && event.type) {
      if (event.type === 'loadedmetadata') {
        if (this.#rmp.srcChangeAutoplay) {
          this.#rmp.play().catch(warning => {
            this.#rmp.rmpUtils.warning(1014, warning);
          });
        } else {
          this.#rmp.rmpUIManagement.showCentralPlay();
          this.#rmp.showPoster();
        }
        if (this.#rmp.googleCastConnected) {
          Logger.print('google-cast', 'casting is engaged - change cast URL on receiving device');
          this.#rmp.rmpGoogleCast.loadCastMedia(true);
        }
        this.#fireSrcChanged();
      } else if (event.type === 'error') {
        this.#rmp.changingSrc = false;
        this.#rmp.rejectPromise('setSrc', this.#rmp.errorData);
      }
    }
  }

  #resetSrc(pdIndex) {
    // reset ABR mode when supported
    if (!this.#rmp.innerAbrAutoMode && this.#rmp.readingMse) {
      this.#rmp.innerAbrAutoMode = true;
      this.#rmp.dispatch('abrstatuschanged');
    }
    // reset analytics
    this.#rmp.analyticsSecondsPlayed = 0;
    // remove chapters 
    if (this.#rmp.rmpChapters) {
      this.#rmp.rmpChapters.destroy();
    }
    if (this.#rmp.rmpThumbnails) {
      this.#rmp.rmpThumbnails.destroy();
    }
    // remove error message if needed
    const errorNode = this.#rmp.dom.content.querySelector('.rmp-error');
    if (errorNode) {
      FW.removeElement(errorNode);
    }
    const errorText = this.#rmp.dom.content.querySelector('.rmp-error-text');
    if (errorText) {
      FW.removeElement(errorText);
    }
    // update UI + remove v8 UI 
    this.#rmp.dom.container.classList.remove(
      'rmp-linear-ad-ui',
      'rmp-module-open-ui',
      'rmp-ad-no-ui',
      'rmp-audio-ui'
    );
    // in case CC are presents (ccFiles) and we are in multiple PD source context 
    // when there is a setSrc and CC already present we need to keep CC UI
    let isPdSwap = false;
    if (typeof pdIndex === 'number' && pdIndex > -1) {
      isPdSwap = true;
    }
    if (!isPdSwap) {
      this.#rmp.dom.container.classList.remove('rmp-captions-ui');
    }
    this.#rmp.rmpUIManagement.showLoadingSpin();
    this.#rmp.one('srcchanged error', () => {
      this.#rmp.rmpUIManagement.hideLoadingSpin();
    });
    this.#rmp.rmpUIManagement.showChrome();
    this.#rmp.rmpModuleManagement.closeAll();
    // remove UI element
    if (!this.#rmp.setSrcPDModule) {
      if (this.#rmp.dom.quality) {
        this.#rmp.rmpModuleManagement.destroy('quality');
      }
      if (this.#rmp.dom.audio) {
        this.#rmp.rmpModuleManagement.destroy('audio');
      }
      if (this.#rmp.rmpCCManagement) {
        this.#rmp.rmpCCManagement.destroy();
      }
      // reset control bar for on-demand content
      if (this.#rmp.dom.current && this.#rmp.dom.handle && this.#rmp.dom.timeElapsedText) {
        this.#rmp.dom.current.style.width = 0;
        this.#rmp.dom.handle.style.left = 0;
        FW.setText(this.#rmp.dom.timeElapsedText, '00:00');
      }
    }
    // for setSrc to work from live to VOD and VOD to live
    this.#rmp.isVod = true;
    this.#rmp.isLive = false;
    this.#rmp.detectLive = true;
    this.#rmp.firstDurationChange = true;
    this.#rmp.dom.container.classList.remove('rmp-live');
    if (this.#rmp.dom.timeElapsedText) {
      FW.setText(this.#rmp.dom.timeElapsedText, '00:00');
    }
  }

  #resetAds() {
    if (this.#rmp.rmpAdsIma) {
      if (this.#rmp.adLinear) {
        this.#rmp.one('adcontentresumerequested', () => {
          this.#rmp.rmpAdsIma.resetAdsForNewRequest();
          this.#setSrcAdReset = true;
        });
        this.#rmp.stopAds().catch(error => {
          this.#rmp.rmpUtils.warning(1021, error);
        });
      } else {
        this.#rmp.rmpAdsIma.resetAdsForNewRequest();
        this.#setSrcAdReset = true;
      }
    } else if (this.#rmp.rmpVast) {
      this.#rmp.one('addestroyed', () => {
        this.#setSrcAdReset = true;
      });
      this.#rmp.stopAds().catch(error => {
        this.#rmp.rmpUtils.warning(1021, error);
      });
    }
  }

  #resetHtml5MediaBuffer() {
    this.#rmp.dom.video.src = this.#rmp.startingSrcUri;
    try {
      // we need call load for Chrome data saver mode
      this.#rmp.dom.video.load();
    } catch (warning) {
      console.warn(warning);
    }
  }

  #readingNextSrc() {
    // reset next reading
    this.#nextReadingMp4 = false;
    this.#nextReadingHlsJS = false;
    this.#nextReadingShaka = false;
    this.#nextReadingHls = false;
    if (this.#rmp.hasDash && this.#rmp.okShaka && this.#rmp.dashFirst) {
      this.#nextReadingShaka = true;
      this.#rmp.startingSrcUri = this.#rmp.src.dash;
    } else if (this.#rmp.hasFps && this.#rmp.okFps) {
      this.#nextReadingHls = true;
      this.#rmp.startingSrcUri = this.#rmp.src.fps;
    } else if (this.#rmp.hasHls && this.#rmp.okHlsJS && this.#rmp.hlsEngine === 'hlsjs') {
      this.#nextReadingHlsJS = true;
      this.#rmp.startingSrcUri = this.#rmp.src.hls;
    } else if (this.#rmp.hasHls && this.#rmp.okShaka && this.#rmp.hlsEngine === 'shakaplayer') {
      this.#nextReadingShaka = true;
      this.#rmp.startingSrcUri = this.#rmp.src.hls;
    } else if (this.#rmp.hasHls && this.#rmp.okHls) {
      this.#nextReadingHls = true;
      this.#rmp.startingSrcUri = this.#rmp.src.hls;
    } else if (this.#rmp.hasDash && this.#rmp.okShaka) {
      this.#nextReadingShaka = true;
      this.#rmp.startingSrcUri = this.#rmp.src.dash;
    } else {
      if (this.#rmp.audioOnly) {
        if (this.#rmp.hasM4a && (this.#rmp.okM4a || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.startingSrcUri = this.#rmp.src.m4a;
        } else if (this.#rmp.hasMp3 && (this.#rmp.okMp3 || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.startingSrcUri = this.#rmp.src.mp3;
        } else if (this.#rmp.hasOgg && (this.#rmp.okOgg || this.#rmp.pdCheckCodecsDone)) {
          this.#rmp.startingSrcUri = this.#rmp.src.ogg;
        } else {
          this.#rmp.rmpUtils.error(107);
        }
      } else {
        if (this.#rmp.hasMp4 && (this.#rmp.okMp4 || this.#rmp.pdCheckCodecsDone)) {
          this.#nextReadingMp4 = true;
          this.#rmp.startingSrcUri = this.#rmp.src.mp4[0];
        } else if (this.#rmp.hasWebM && (this.#rmp.okWebM || this.#rmp.pdCheckCodecsDone)) {
          this.#nextReadingMp4 = true;
          this.#rmp.startingSrcUri = this.#rmp.src.webm[0];
        } else if (this.#rmp.playlistAudioOnly || this.#rmp.relatedAudioOnly || this.#rmp.audioOnlyUseVideoLayout) {
          if (this.#rmp.hasM4a && (this.#rmp.okM4a || this.#rmp.pdCheckCodecsDone)) {
            this.#rmp.startingSrcUri = this.#rmp.src.m4a;
          } else if (this.#rmp.hasMp3 && (this.#rmp.okMp3 || this.#rmp.pdCheckCodecsDone)) {
            this.#rmp.startingSrcUri = this.#rmp.src.mp3;
          } else if (this.#rmp.hasOgg && (this.#rmp.okOgg || this.#rmp.pdCheckCodecsDone)) {
            this.#rmp.startingSrcUri = this.#rmp.src.ogg;
          } else {
            this.#rmp.rmpUtils.error(107);
          }
        } else {
          this.#rmp.rmpUtils.error(107);
        }
      }
    }
  }

  #resetBuffer() {
    this.#rmp.on('loadedmetadata error', this.#afterSrcSwitchFn);
    if (this.#rmp.readingHlsJS) {
      if (this.#rmp.rmpHlsJS) {
        this.#rmp.rmpHlsJS.destroy();
      }
      if (this.#rmp.dom.video.textTracks.length > 0) {
        const isMuted = this.#rmp.mute;
        this.#resetHtml5VideoTagEvents();
        this.#rmp.dom.content.removeChild(this.#rmp.dom.video);
        this.#rmp.rmpInitManagement.createVideoTag();
        if (this.#rmp.readingPDorNative) {
          this.#rmp.rmpUtils.refreshHtml5VideoErrorManagement();
        }
        this.#rmp.dom.content.appendChild(this.#rmp.dom.video);
        this.#reAttachHtml5VideoEvents();
        // make sure muted state is preserved if we remove and re-add video tag (e.g. audio playlist)
        if (isMuted) {
          this.#rmp.mute = true;
        }
        try {
          this.#rmp.dom.video.load();
        } catch (warning) {
          console.warn(warning);
        }
      }
      this.#runNextPlayer();
    } else if (this.#rmp.readingShaka) {
      if (this.#rmp.rmpShakaPlayer) {
        this.#rmp.rmpShakaPlayer.destroy();
      }
      if (this.#rmp.shakaPlayer) {
        this.#rmp.shakaPlayer.destroy().then(() => {
          this.#runNextPlayer();
        });
      } else {
        this.#runNextPlayer();
      }
    } else {
      if (this.#rmp.rmpNativeHls) {
        this.#rmp.rmpNativeHls.destroy();
      }
      this.#runNextPlayer();
    }
  }

  #prepSrcSwitchShakaNotInitialized() {
    this.#rmp.rmpUIManagement.showCentralPlay();
    if (!this.#rmp.rmpShakaPlayer) {
      this.#rmp.rmpShakaPlayer = new ShakaPlayer(this.#rmp);
    }
    this.#rmp.msePreloadRequested = false;
    this.#rmp.rmpShakaPlayer.init();
    this.#rmp.msePreloadRequested = true;
    this.#rmp.on('loadedmetadata error', this.#afterSrcSwitchFn);
  }

  clear() {
    window.clearInterval(this.#setSrcResetAdInterval);
  }

  init(src, pdIndex) {
    this.#rmp.preload = 'auto';
    // remove replay icon in case it is here
    this.#rmp.rmpEventsManagement.removeReplayIcon();
    this.#rmp.dispatch('srcchanging');

    // Analytics (Bitmovin) update for progressive
    if (this.#rmp.readingPDorNative && this.#rmp.bitmovinAnalyticsConfig.key &&
      typeof this.#rmp.bitmovinAnalyticsConfig.key === 'string') {
      Logger.print('bitmovin analytics',
        'updating native HTML5 video analytics support', this.#rmp.bitmovinAnalyticsConfig);
      this.#rmp.bitmovinAnalytics.sourceChange(this.#rmp.bitmovinAnalyticsConfig);
      Logger.print('bitmovin analytics', 'bitmovinAnalytics', this.#rmp.bitmovinAnalytics);
    }

    this.#rmp.src = src;
    InnerDefaults.resetHasStreamType.call(this.#rmp);
    this.#rmp.rmpUtils.detectSrc();
    this.#readingNextSrc();
    Logger.print('api', 'setSrc starts - filtered input is ' + this.#rmp.startingSrcUri);

    // update cast item if engaged
    this.#rmp.googleCastUrl = this.#rmp.startingSrcUri;
    // remove error UI if any
    this.#rmp.dom.container.classList.remove('rmp-error-ui');
    // reset post setSrc operations
    // for MP4/WebM passing Array
    if (this.#rmp.readingMp4 && ((Array.isArray(src.webm) && src.webm.length > 0) ||
      (Array.isArray(src.mp4) && src.mp4.length > 0))) {
      if (Array.isArray(src.webm) && this.#rmp.readingWebM) {
        this.#rmp.src.mp4 = src.webm;
      } else if (Array.isArray(src.mp4)) {
        this.#rmp.src.mp4 = src.mp4;
      }
      if (typeof pdIndex === 'number' && pdIndex > -1) {
        this.#rmp.googleCastUrl = this.#rmp.startingSrcUri = this.#rmp.src.mp4[pdIndex];
      } else {
        this.#rmp.filteredInitialQuality = FW.filterInitialQuality(this.#rmp.initialQuality, this.#rmp.src.mp4);
        this.#rmp.googleCastUrl = this.#rmp.startingSrcUri = this.#rmp.src.mp4[this.#rmp.filteredInitialQuality];
      }
    }

    // to update CC and audio tracks overlay icons
    if (this.#rmp.updateOverlayModuleSelectionFn) {
      this.#rmp.off('playing', this.#rmp.updateOverlayModuleSelectionFn);
    }

    if (this.#afterSrcSwitchFn) {
      this.#rmp.off('loadedmetadata error', this.#afterSrcSwitchFn);
    } else {
      this.#afterSrcSwitchFn = this.#afterSrcSwitch.bind(this);
    }

    // reset
    this.#resetSrc(pdIndex);
    if (!this.#rmp.rmpPlaybackManagement.playerInitialized) {
      Logger.print('api', 'setSrc called but player has not been initialized yet');
      if (this.#rmp.readingPDorNative) {
        this.#resetHtml5MediaBuffer();
        this.#rmp.rmpUIManagement.showCentralPlay();
        this.#rmp.on('loadedmetadata error', this.#afterSrcSwitchFn);
      } else if (this.#rmp.readingHlsJS) {
        if (this.#rmp.rmpHlsJS) {
          this.#rmp.rmpHlsJS.destroy();
        } else {
          this.#rmp.rmpHlsJS = new HlsJS(this.#rmp);
        }
        this.#rmp.rmpUIManagement.showCentralPlay();
        this.#rmp.msePreloadRequested = false;
        this.#rmp.rmpHlsJS.init();
        this.#rmp.msePreloadRequested = true;
        this.#rmp.on('loadedmetadata error', this.#afterSrcSwitchFn);
        return;
      } else if (this.#rmp.readingShaka) {
        if (this.#rmp.rmpShakaPlayer) {
          this.#rmp.rmpShakaPlayer.destroy();
        }
        if (this.#rmp.shakaPlayer) {
          this.#rmp.shakaPlayer.destroy().then(() => {
            this.#prepSrcSwitchShakaNotInitialized();
          });
        } else {
          this.#prepSrcSwitchShakaNotInitialized();
        }
        return;
      }
    }
    if (this.#rmp.ads) {
      // remove ad marker from VMAP and ad-scheduler
      this.#rmp.rmpAdsHelpers.clearAdMarkers();
      if (this.#rmp.imaAdsManager) {
        this.#rmp.contentCompleteCalled = false;
      } else if (this.#rmp.rmpVast) {
        this.#rmp.rmpVast.contentPlayerCompleted = false;
      }
      if (this.#rmp.adOnStage) {
        this.#resetAds();
        this.clear();
        this.#setSrcResetAdInterval = window.setInterval(() => {
          if (this.#setSrcAdReset) {
            this.clear();
            this.#setSrcAdReset = false;
            this.#resetBuffer();
          }
        }, 40);
      } else {
        this.#resetBuffer();
      }
    } else {
      this.#resetBuffer();
    }
  }
}
